const MD5 = require('js-md5');
const cloneDeep = require('clone-deep');

// 时间格式化
function dateFtt(fmt, date) { //author: meizz   
    var o = {
        "M+": date.getMonth() + 1,                 //月份   
        "d+": date.getDate(),                    //日   
        "h+": date.getHours(),                   //小时   
        "m+": date.getMinutes(),                 //分   
        "s+": date.getSeconds(),                 //秒   
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
        "S": date.getMilliseconds()             //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

// 根据百度地图SK计算SN
function calcSN(queryStr, SK) {
    let encodeStr = encodeURIComponent(queryStr);
    let rawStr = encodeStr + SK
    let SN = MD5(rawStr);
    return SN;
}


export default {
    install(Vue, options) {
        Vue.prototype.dateFormat = dateFtt;
        Vue.prototype.cloneDeep = cloneDeep;
        Vue.prototype.calcSN = calcSN;
    }
}
